/*
 * @Author: zhengxiaowen
 * @Date: 2018-08-24 23:55:07
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:33:19
 */


import platform from '@/config/platform'

let host = platform.host

let _srmServer = platform.url.srmServer
let _baseServer = platform.url.baseServer
// PC移入
let hostname = window.location.hostname;
let bigFileHost = platform.bigFileHost;
let resourceServerName = "/resourceServer";
let projectClueServerName = "/projectClueServer";
let fileServerUrl = platform.url.fileServer;
let srmServerUrl = platform.url.srmServer;
let bpmServer = platform.url.bpmServer;

let api = {
    // 快码查询
    baseLookupTypeService_find: `${_baseServer}/baseLookupTypeService/find`,

    /**
     * 移动端登录及首页
     */
    //登录
    login: `${_baseServer}/baseLoginService/login`,
    //微信授权登录
    wechat_login: `${_srmServer}/v1/scsi/srmWechatAuthorization/login`,
    //获取验证码
    generateRandomValidate: `${_baseServer}/baseLoginService/generateRandomValidate`,
    //数据字典快码查询
    baseLookupTypeService_findDic: `${_baseServer}/baseLookupValuesService/findDic`,
    //获取功能菜单(根据职责Id)
    findBaseMenuByRespId: `${_baseServer}/baseMenuService/findBaseMenuByRespId`,
    // 获取当前微信用户OpenID
    getWechatAuthorizeOpenId: `${_baseServer}/wxLoginService/wechat/web/authorize/openId`,

    /**
     * 供应商管理
     */
    //供应商待办列表查询
    srmMobileSupplierPendingRestful_listByPage: `${_srmServer}/v1/srmMobileSupplierPendingRestful/listByPage`,
    //供应商通知查询
    srmBaseNotificationRestful_listByPage: `${_srmServer}/v1/srmBaseNotificationRestful/listByPage`,
    //供应商档案列表
    querySupplierInfoList: `${_srmServer}/v1/srmMobileSupplierInfoRestful/querySupplierInfoList`,
    //供应商档案查看
    querySupplierInfoById: `${_srmServer}/v1/srmMobileSupplierInfoRestful/querySupplierInfoById`,
    //绩效结果查看
    listSpePerformance: `${_srmServer}/v1/srmMobilePerformanceRestful/listSpePerformance`,
    srmSpePerformanceGde_listByPage: `${srmServerUrl}/v1/srmSpePerformanceRestful/listGdsByPage`, /*  分页查询绩效结果 */

    srmSpeQuarterlyScore_listByPage: `${srmServerUrl}/v1/srmSpeSubjectiveScoreRestful/quarterlyScoreByPage`, /*  分页查询绩效结果 */
    srmSpeAnnualScore_listByPage:`${srmServerUrl}/v1/srmSpeSubjectiveScoreRestful/annualScoreByPage`, /*  分页查询年度绩效汇总表 */

  accountStmt_listByPage: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/listByPage`, /* 分页查询对账单表 */
  accountStmt_findById: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/findById`, /* 根据KEY ID查询对账单表 */
  accountStmtDe_listByPage: `${srmServerUrl}/v1/srmRcnAccountStmtDeRestful/listByPage`, /* 对账单扣款表分页查询列表 */
  accountStmtLine_listByPage: `${srmServerUrl}/v1/srmRcnAccountStmtLineRestful/listByPage`, /*  分页查询对账单对账单行表 */


    /**
     *  内部待办表
     */
    interiorPending_listByPage: `${_srmServer}/v1/srmBaseInteriorPendingRestful/listByPage`,
    /* 根据KEY ID查询系统公告表 */
    notice_findById: `${_srmServer}/v1/srmBaseNoticeRestful/findById`,
    /*  分页查询系统公告表 */
    notice_listByPage: `${_srmServer}/v1/srmBaseNoticeRestful/listByPage`,
    /*  分页查询系统公告概要 */
    notice_listSummaryByPage: `${_srmServer}/v1/srmBaseNoticeRestful/listSummaryByPage`,

    /* Begin 通知表 API列表 */
    srmBaseNotification_listByPage: `${_srmServer}/v1/srmBaseNotificationRestful/listByPage`, /*  分页查询通知表 */

    /* End 通知表 API列表 */
    /**
     * 寻源协同
     */
    //报价列表查看
    molieListByPage: `${_srmServer}/v1/srmSfdMobileRespondHeader/molieListByPage`,
    //报价参与或拒绝
    mobileSaveSupplierReply: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileSaveSupplierReply`,
    //投标（创建报价单）
    mobileCreateRespond: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileCreateRespond`,
    bidHeaderRestful_doCreateBid: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doCreateBid`, /* 创建供应商报价单(询价) */

    bidHeaderRestful_listByPage: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/listByPage`,
    //报价编辑详情
    mobileFindById: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileFindById`,
    mobileFindById111: `${_srmServer}/v1/srmSfdBidHeaderRestful/findById`,
    auctionHeaderRestful_findById: `${srmServerUrl}/v1/srmSfdAuctionHeaderRestful/findById`,
    auctionItemRestful_listAuctionItem: `${srmServerUrl}/v1/srmSfdAuctionItemRestful/listAuctionItem`,
    bidItemRestful_listSfdBidItem: `${srmServerUrl}/v1/srmSfdBidItemRestful/listSfdBidItem`,/*报价行信息*/
    bidHeaderRestful_doCreateBargaining: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doCreateBargaining`, /* 创建供应商议价单(询价) */
    pay_list_listByPage: `${srmServerUrl}/v1/srmBasePaymentTermRestful/listByPage`, // 付款条件表分页查询列表
    //报价编辑保存
    moblieSaveOrUpdate: `${_srmServer}/v1/srmSfdMobileRespondHeader/moblieSaveOrUpdate`,
    bidHeaderRestful_saveOrUpdate: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/saveOrUpdate`,
    bidHeaderRestful_doSubmit: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doSubmit`,/* 提交报价 */
    //报价编辑提交
    mobileDoSubmit: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileDoSubmit`,
    //上传附件接口
    fileUpload: `${fileServerUrl}/v2/file/upload`,
    //下载附件接口
    batchDownload: `${fileServerUrl}/v2/file/batchDownload`,
    //下载接口（获取下载文件url地址）
    getFileUrl: `${fileServerUrl}/v2/file/getFileUrl`,
    //v2文件多个文件打包下载服务
    v2ListBaseFile: `${fileServerUrl}/v2/file/listBaseFile`,
    //v1超大文件下载服务,使用Body传参
    v2FileDownloadBody: `${fileServerUrl}/v2/file/downloadBody`,

    /**
     * 询价
     */
    //询价报价（询价报价列表查询）
    listByPageForBidToMobile: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/listByPageForBidToMobile`,
    //询价报价（询价报价-回应）
    doAnswerForSupp: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/doAnswerForSupp`,
    //询价报价（询价报价-拒绝）
    doRefuseForSupp: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/doRefuseForSupp`,

    /**
     * 订单协同
     */
    //客户订单（订单查询--按头信息查询数据）
    orderListByPage: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByPage`,
    //客户订单（订单确认--按物料查询明细）
    orderListByDetailPage: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByDetailPage`,
    //客户订单（详情头信息1）
    orderMobileFindById: `${_srmServer}//v1/srmMobileOrderHeaderRestful/mobileFindById`,
    //客户订单（详情行信息-物料2）
    orderListByPageLine: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByPageLine`,
    //客户订单（交期确认）
    doSupplierDeliveryConfirm: `${_srmServer}/v1/srmMobileOrderHeaderRestful/doSupplierDeliveryConfirm`,

    /**
     * 送货协同
     */
    //订单协同（送货通知单查询列表）
    listMobileDeliveryNotice: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listMobileDeliveryNotice`,
    //订单协同（送货通知单查询头-详情1）
    noticeFindById: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/noticeFindById`,
    //订单协同（送货通知单查询行-详情2）
    listByPageToMobile: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listByPageToMobile`,
    //订单协同（送货单查询列表）
    listMobileDeliveryNote: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listMobileDeliveryNote`,
    //listMobileDeliveryNote: `${_srmServer}/v1/srmPurDeliveryNoteHeaderRestful/listByPage`,
    //订单协同（送货单查询头-详情1）
    deliveryNoteHeader_findById: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/notefindById`,
    srmPurDeliveryNoteHeader_findById: `${srmServerUrl}/v1/srmPurDeliveryNoteHeaderRestful/findById`, /* 根据KEY ID查询送货单头 */
  srmPurDeliveryNoticeLine_listDeliveryNoticeByPage: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/listDeliveryNoticeByPage`, /* 分页查询送货通知单 */

  //订单协同（送货单查行-详情2）
    deliveryNoteLine_listLineByPage: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listLineByPageToMobile`,
    srmPurDeliveryNoticeHeader_saveOrUpdate: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/saveOrUpdate`, /* 保存送货通知单头 */

    /**
     * 微信公众号
     */
    //获取微信网页授权内容
    wechat_authorize: `${_srmServer}/v1/srmWechatAuthorization/authorize`,
    //微信授权获取openId
    wechat_userInfo: `${_srmServer}/v1/srmWechatAuthorization/userInfo`,
    //更新用户微信openId
    updateWxOpenIdById: `${_baseServer}/baseUsersService/updateWxOpenIdById`,
    //获取JS认证码
    wechatJsApiGenerateSignature: `${_baseServer}/wxLoginService/generate/jsapi/signature`,

    /* Begin 竞价单消息表 API列表 */
    competeHall_doCompeteHallTurnProcess: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCompeteHallTurnProcess`, /*  启动、暂停竞价 */
    competeHall_doInitCacheSupplier: `${_srmServer}/v1/srmSfdCompeteHallRestful/doInitCacheSupplier`, /*  初始化供应商到缓存并生成随机编码 */
    competeHall_getCompeteSupplierInfo: `${_srmServer}/v1/srmSfdCompeteHallRestful/getCompeteSupplierInfo`, /*  从竞价供应商缓存查找供应商信息 */
    competeHall_doCacheSupplierReady: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCacheSupplierReady`, /*  竞价供应商准备就绪状态更新 */
    competeHall_doSupplierOfferPrice: `${_srmServer}/v1/srmSfdCompeteHallRestful/doSupplierOfferPrice`, /* 供应商出价 */
    competeHall_listCacheNewestSupplierOfferItems: `${_srmServer}/v1/srmSfdCompeteHallRestful/listCacheNewestSupplierOfferItems`, /* 获取供应商最新报价物料信息  */
    competeHall_listCacheNewestCompeteOfferHeader: `${_srmServer}/v1/srmSfdCompeteHallRestful/listCacheNewestCompeteOfferHeader`, /* 查询查询所有供应商最新报价信息  */
    competeHall_doCloseCompeteHall: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCloseCompeteHall`, /*  关闭竞价大厅，并更新数据到招标单据的报价单 */
    competeNotice_listCompeteNotice: `${_srmServer}/v1/srmSfdCompeteNoticeRestful/listCompeteNotice`, /*  查询竞价单消息表 */
    competeOfferHeader_listByPage: `${_srmServer}/v1/srmSfdCompeteOfferHeaderRestful/listByPage`, /*  查询竞价报价单列表 */
    competeOfferHeader_findById: `${_srmServer}/v1/srmSfdCompeteOfferHeaderRestful/findById`, /*  查询竞价报价单头明细 */
    competeOfferItem_listByPage: `${_srmServer}/v1/srmSfdCompeteOfferItemRestful/listByPage`, /*  查询竞价报价单行列表 */

    /* End 竞价单消息表 API列表 */

    /* Begin 竞价单竞价轮次信息表 API列表 */
    competeTurn_findById: `${_srmServer}/v1/srmSfdCompeteTurnRestful/findById`, /* 根据KEY ID查询竞价单竞价轮次信息表 */
    competeTurn_listByPage: `${_srmServer}/v1/srmSfdCompeteTurnRestful/listByPage`, /*  分页查询竞价单竞价轮次信息表 */
    competeTurn_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteTurnRestful/saveOrUpdate`, /*  保存竞价轮次信息 */
    competeTurnParam_listByPage: `${_srmServer}/v1/srmSfdCompeteTurnParamRestful/listByPage`, /*  分页查询竞价单竞价轮次信息参数表 */
    competeTurnParam_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteTurnParamRestful/saveOrUpdate`, /* 保存竞价单竞价轮次信息参数表 */
    /* End 竞价单竞价轮次信息表 API列表 */


    biddingDoc_doCreateCompete: `${_srmServer}/v1/srmSfdBiddingDocRestful/doCreateCompete`,  /* 招标创建竞价单 */
    biddingDoc_listByPageToCompete: `${_srmServer}/v1/srmSfdBiddingDocRestful/listByPageToCompete`,  /* 分页查询招标文件表（竞价） */

    slcApprovalProcessRestful_listByPage: `${srmServerUrl}/v1/srmSlcApprovalProcessRestful/listByPage`, /*  分页查询供应商注册审批表 */

    competeHeader_listByPage: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/listByPage`,  /* 分页查询竞价接口 */
    competeHeader_findById: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/findById`,  /* 根据ID，查询竞价接口 */
    competeHeader_delete: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/delete`,  /* 删除竞价接口 */
    competeHeader_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/saveOrUpdate`,  /* 保存竞价接口 */
    competeHeader_doSubmit: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSubmit`,  /* 提交竞价接口 */
    competeHeader_doReject: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doReject`,  /* 驳回竞价接口 */
    competeHeader_doApproval: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doApproval`,  /* 批准竞价接口 */
    competeHeader_doSaveAwardByItem: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSaveAwardByItem`,  /* 保存竞价按物料中标的数据接口 */
    competeHeader_doSubmitByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSubmitByAward`,  /* 提交竞价决标数据接口 */
    competeHeader_doRejectByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doRejectByAward`,  /* 驳回竞价决标数据接口 */
    competeHeader_doApprovalByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doApprovalByAward`,  /* 批准竞价决标数据接口 */
    competeHeader_doOpenCompeteHall: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doOpenCompeteHall`,  /* 开启竞价大厅接口 */
    competeHeader_doCreateResult: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doCreateResult`,  /* 竞价创建结果接口 */
    competeHeader_doImportCompeteItem: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doImportCompeteItem`,  /* 竞价,批量导入标的物 */
    competeItem_listByPage: `${_srmServer}/v1/srmSfdCompeteItemRestful/listByPage`,  /* 分页查询竞价的物料接口 */
    competeItem_delete: `${_srmServer}/v1/srmSfdCompeteItemRestful/delete`,  /* 删除竞价的物料接口 */
    competeItem_listCompeteItemByAward: `${_srmServer}/v1/srmSfdCompeteItemRestful/listCompeteItemByAward`,  /* 竞价按物料定价汇总接口 */
    competeSupplier_listByPage: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/listByPage`,  /* 分页查询竞价的供应商接口 */
    competeSupplier_delete: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/delete`,  /* 删除竞价的供应商接口 */
    competeSupplier_doCompeteSupplierFeedback: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/doCompeteSupplierFeedback`,  /* 供应商参与、拒绝竞价反馈 */

    /* Begin 资质审查头表 API列表 */
    slcQualifyHeader_findById: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/findById`,/* 根据KEY ID查询资质审查头表 */
    slcQualifyHeader_listByPage: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/listByPage`,  /* 供应商资质审查 */
    slcQualifyCategory_listByPage: `${_srmServer}/v1/srmSlcSupplierCategoriesRestful/listByPage`,  //分页查询供应商的采购分类
    slcQualifySite_listByPage: `${_srmServer}/v1/srmSlcQualifySiteRestful/listByPage`,/*  分页查询资质审查地点行表 */
    slcQualifyHeader_doApproval: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/doQualifyApproval`,/* 审批资质审查单据 */
    slcQualifyHeader_doReject: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/doQualifyReject`,/* 驳回资质审查单据 */
    /* End 资质审查头表 API列表 */

    /* Begin 供应商日常管理表 API列表 */
    srmSlcDailyManage_listByPage: `${srmServerUrl}/v1/srmSlcDailyManageRestful/listByPage`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_saveOrUpdate: `${srmServerUrl}/v1/srmSlcDailyManageRestful/saveOrUpdate`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_findById: `${srmServerUrl}/v1/srmSlcDailyManageRestful/findById`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_queryManageInfoById: `${srmServerUrl}/v1/srmSlcDailyManageRestful/queryManageInfoById`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_querySitesByLocationId: `${srmServerUrl}/v1/srmSlcDailyManageRestful/querySitesByLocationId`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_doBatchSaveOrUpdate: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doBatchSaveOrUpdate`, /* 批量保存、更新供应商日常管理表 */
    srmSlcDailyManage_delete: `${srmServerUrl}/v1/srmSlcDailyManageRestful/delete`, /* 删除供应商日常管理表 */
    srmSlcDailyManage_doSubmit: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageSubmit`,/* 审批日常管理单据 */
    srmSlcDailyManage_doApproval: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageApproval`,/* 审批日常管理单据 */
    srmSlcDailyManage_doReject: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageReject`,/* 驳回日常管理单据 */
    srmSlcDailyManage_doAbolish: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doAbolish`,/* 作废日常管理单据 */
    /* End 供应商日常管理表 API列表 */

    /**供应商注册*/
    registerInfoRestful_listByPage: `${srmServerUrl}/v1/srmSlcRegisterInfoRestful/listByPage`,  //分页查询需审核的供应商的注册资料
    registerInfoRestful_listByPageManage: `${srmServerUrl}/v1/srmSlcRegisterInfoRestful/listByPageHead`,  //分页查询需领导审核的供应商的注册资料
    registerInfoRestful_getRegisterInfoVOByApprovalId: `${srmServerUrl}/v1/srmSlcRegisterInfoRestful/getRegisterInfoVOByApprovalId`,  //根据注册ID，获取供应商的注册资料
    baseOrganizationService_findPagination: `${_baseServer}/baseOrganizationService/findPagination`, // 根据用户数据权限查询组织信息
    baseUsersService_findPagination: `${_baseServer}/baseUsersService/findPagination`,
    registerInfoRestful_registerApproval: `${srmServerUrl}/v1/srmSlcRegisterInfoRestful/registerApproval`,  //批准或驳回供应商的注册资料
    registerInfoRestful_editRegisterApproval: `${srmServerUrl}/v1/srmSlcRegisterInfoRestful/editRegisterApproval`,  //修改一级审批人

    /**供应商变更*/
    changeInfoRestful_listByPage: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/listSrmSlcChangeInfoInside`,  //分页查询供应商的变更单信息
    changeInfoRestful_findById: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/findById`,  //根据变更ID，查询变更单信息
    supplierInfoRestful_querySupplierInfoById: `${srmServerUrl}/v1/srmSlcSupplierInfoRestful/querySupplierInfoById`,  //查询指定ID的供应商资料
    changeInfoRestful_reject: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/rejectChangeInfo`,  //根据变更ID，驳回变更单信息
    changeInfoRestful_approval: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/approvalChangeInfo`,  //根据变更ID，审批变更单信息
    changeInfoRestful_handOverBuyer: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/handOverBuyer`, /* 移交至一级审批人审批*/

    /**招标文件发布*/
    biddingDoc_listByPageToPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/listByPageToPublish`,  /* 分页查询招标文件表（发标） */
    biddingDoc_findById: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/findById`,  /* 根据ID，查询招标文件接口 */
    biddingDoc_doRejectPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/doRejectPublish`,  /* 驳回发标接口 */
    biddingDoc_doApprovalPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/doApprovalPublish`,  /* 审批发标接口 */

    /***/
    cctAcceptLogRestful_listByPage: `${_srmServer}/v1/srmCctAcceptLogRestful/listByPage`,  /* 验收日志 */
    cctAcceptLogRestful_receiveAccept: `${_srmServer}/v1/srmCctAcceptLogRestful/receiveAccept`,  /* 验收操作 */
    cctCommissioningAcceptanceRestful_findById: `${_srmServer}/v1/srmCctCommissioningAcceptanceRestful/findById`,  /* 安装调试验收单详情 */
    cctCommissioningAcceptanceRestful_listByPage: `${_srmServer}/v1/srmCctCommissioningAcceptanceRestful/listByPage`,  /* 安装调试验收单列表 */
    cctReceiptHeaderRestful_findById: `${_srmServer}/v1/srmCctReceiptHeaderRestful/findById`,  /* 到货验收单详情 */
    cctReceiptHeaderRestful_listByPage: `${_srmServer}/v1/srmCctReceiptHeaderRestful/listByPage`,  /* 到货验收单列表 */
    cctReceiptLineRestful_listByPage: `${_srmServer}/v1/srmCctReceiptLineRestful/listByPage`,  /* 到货验收单列表 */


}

export default api;



// WEBPACK FOOTER //
// ./src/page/srm/config/api.js